import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { FormHelperText, InputLabel } from '@material-ui/core';
import { InputField } from '../../healtheraComponents';
import { InputProps } from './types';
import InfoTooltip from '../InfoTooltip';

interface TextEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  label: string;
  id?: string;
  optional?: boolean;
  tooltip?: string;
  helperText?: string;
}

function TextEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
  id,
  disabled,
  optional,
  tooltip,
  helperText,
}: TextEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <InputLabel htmlFor={id} error={Boolean(fieldState.error)}>
            {label}
            {tooltip && <InfoTooltip title={tooltip} />}
          </InputLabel>
          <div>
            <InputField
              id={id}
              error={fieldState.error?.message}
              value={field.value || ''}
              onChange={field.onChange}
              disabled={disabled}
              required={!optional}
            />
            {helperText && !fieldState.error && <FormHelperText>{helperText}</FormHelperText>}
          </div>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default TextEditor;
